module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "big-slogan-blue"
  }, [_vm._v(_vm._s(_vm.$t("contact.pageHeader")))])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "all-categories mb-20"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("contact.contactUs")))])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('at')) + " "), _vm._m(0), _vm._v("\n            , " + _vm._s(_vm.$t('contact.mission')) + "\n          ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("contact.description")))]), _vm._v(" "), _c('div', {
    staticClass: "row domore-blue-1-light-bgd mt-20 mb-20 pt-10 m-0"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t("contact.companyName")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("contact.address")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-phone-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t("contact.phoneNumber")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "info@domore.live"
    }
  }, [_vm._v(_vm._s(_vm.$t("contact.email")))])])])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.$t("contact.sloganBottom")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "all-categories mb-20"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("contactForm.title")))])]), _vm._v(" "), _c('form', [_c('input', {
    staticClass: "form-control mb-20",
    attrs: {
      "type": "text",
      "id": "guest-email",
      "placeholder": _vm.$t('contactForm.email')
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control mb-20",
    attrs: {
      "type": "text",
      "id": "guest-subject",
      "placeholder": _vm.$t('contactForm.subject')
    }
  }), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": "8",
      "id": "guest-comment",
      "placeholder": _vm.$t('contactForm.message')
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg button-wide-crowd",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t("contactForm.sendButton")))])])])])]), _vm._v(" "), _c('crowd-or-rais')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sub', [_c('span', {
    staticClass: "logo-font domore-yellow"
  }, [_vm._v("do")]), _c('span', {
    staticClass: "logo-font domore-blue-1"
  }, [_vm._v("MORE")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b62f476"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/About/Contact.vue
// module id = 813
// module chunks = 1